<template>
    <div class="card-body pt-1" >
        <div class="d-flex custom-control custom-checkbox pb-2">
            <input v-bind:id="format.token_value" name="Exports" type="checkbox" v-bind:value="format.token_value" v-model="values.requestedExports" v-bind:disabled="!format.active || values.requestedExports.length >= values.max && values.requestedExports.indexOf(format.token_value) == -1" class="custom-control-input export-option">
            <label v-bind:for="format.token_value" class="custom-control-label d-flex frut-55-roman export-selection ul-dark-grey flex-grow-1">
                {{format.name}}
                <img v-if="format.gen_symbol" class="pl-2 mt-1" src="../assets/images/availability/Symbol.svg" title="Symbol Available">
                <img v-if="format.gen_footprint" class="pl-2 mt-1" src="../assets/images/availability/Footprint.svg" title="Footprint Available">
                <img v-if="format.gen_3d" class="pl-2 mt-1" src="../assets/images/availability/3DModel.svg" title="3d Model Available">
            </label>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ExportFormat',
        props: {
            format: {
                type: Object,
                default: () => {
                    return {
                        id: "",
                        name: "",
                        token_value: "",
                        gen_symbol: "",
                        gen_footprint: "",
                        gen_3d: "",
                        active: "",
                        visible: "",
                        cad_family: "",
                        cad_product: "",
                        cad_version: "",
                        folder_path: "",
                        filename: "",
                        help_ref: "",
                        tool_num: "",
                        version_num: "",
                        is_ul_step: "",
                        is_ul_stl: "",
                        is_mfr_step: "",
                        is_cadence_dehdl: ""
                    }
                }
            },
            values: {
                type: Object,
                default: () => {
                    return {
                        requestedExports: [],
                        max: 5
                    }
                }
            }
        },
    };
</script>
<style scoped>

    .export-group > .card-header {
        background-color: var(--ul-light-gray-bg);
        border-bottom: 1px solid var(--ul-dark-gray);
        padding: 0;
    }

    .export-group > .card-header > a.accordion-toggle {
        color: var(--ul-dark-gray);
        display: block;
        padding: 0;
        cursor: pointer;
        text-decoration: none;
    }

    .custom-checkbox input, .custom-checkbox label {
        cursor: pointer;
    }

    .export-selection > img {
        height: 16px;
    }
    @media(max-width:1299.9px){
        .export-selection > img {
            height: 12px;
        }
    }
</style>
